// Error for a failed request, shared by the Sales, Purchasing and Finance
// services (Chart of Accounts and Company profile included): the server's readable reason as the message, plus its HTTP status
// and (when given) which fields were wrong ({ fieldName: message }), so the
// form can show each reason under its field.
export const requestError = async (res) => {
    let body = null;
    try { body = await res.json(); } catch { }
    const error = new Error(body?.error || body?.message || `HTTP ${res.status}`);
    error.status = res.status;
    if (body?.fields && typeof body.fields === "object") error.fields = body.fields;
    return error;
};
